import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_7: FaireProductEntity = {
  token: "matcha-7",
  type: "product",
  name: "Handmade Matcha Set Sesame",
  brandName: "One DNA",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/934d60f85817067509cb02f1f1514fa2666956f2304de9a58d3f9a6372d37712.png",
  priceDollars: 19,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/934d60f85817067509cb02f1f1514fa2666956f2304de9a58d3f9a6372d37712.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  description: "Handmade ceramic matcha set with bamboo whisk",
  categoryTokens: ["cat_accessories"],
  tags: ["matcha", "tea-set", "ceramic", "handmade", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
